@if (this.subscription) {
  <app-card [fullHeight]='false' header="Abonnementsinformatie">
    <app-badge-with-content icon="address-card" size="small" type="regular" header="Abonnementsnummer" [content]="this.subscription.id" />
    @if ((this.subscription.address | address).length > 0) {
      <app-badge-with-content icon="location-dot" size="small" type="regular" header="Adres" [content]="this.subscription.address | address" />
    }
    <app-badge-with-content icon="wave-pulse" size="small" type="regular" header="Status" [content]="SubscriptionStateLabel[this.subscription.state]" />
    @if (this.subscription.date_activation) {
      <app-badge-with-content icon="calendar-circle-plus" size="small" type="regular" header="Ingangsdatum" [content]="this.subscription.date_activation | date: 'dd-MM-yyyy'" />
    }
    @if (this.subscription.leadtime > 0) {
      <app-badge-with-content icon="clock" size="small" type="regular" header="Contractduur" [content]="this.subscription.leadtime | duration: 'months'" />
    }
    @if (this.subscription.date_expiry && this.subscription.state === SubscriptionState.ACTIVE) {
      <app-badge-with-content icon="calendar-circle-minus" size="small" type="regular" header="Opzegbaar per" [content]="this.subscription.date_expiry | date: 'dd-MM-yyyy'" />
    }
    @if (this.subscription.date_ophef) {
      <app-badge-with-content icon="ban" size="small" type="regular" header="Einddatum" [content]="this.subscription.date_ophef | date: 'dd-MM-yyyy'" />
    }
  </app-card>
}
